import React, { useRef, memo, useEffect, useCallback, useState} from 'react';
import {getDuration} from '../getDuration.js';
import {PIANO_ROLL} from 'constants/arrangement-modes.js';
import {
    setArrangementBottomMode,
    setArrangementCursorStep,
    setArrangementPatternSelected} from 'actions/index.js';
import {getVisualization} from "components/arrangement/getVisualization.js";

import Step from 'components/track/Step.js';
import Colors from 'components/Colors.js';
import {connect} from 'react-redux';
import {getBarWidth} from '../getBarWidth.js';

const colors = new Colors();
const DOUBLE_CLICK = 250;

const TrackPattern = memo((props) => { 
    let lastClick = useRef(0);
    let length = props.pattern.length(props.resolution);
    let style = {
        backgroundColor: colors.getColorForTrack(props.track),
    };
    
    let width = getBarWidth(
        props.duration || 64,
        props.resolution,
        props.xScale);

    let fullStyle = {
        width
    };

    let className = "track-pattern";
    style.width -= 1;

    if (props.event.duration === 0) {
        return '';
    }

    const onClickHeader = useCallback((e) => {
        e.stopPropagation();
        props.track.sequencerEngine.selectTrack(props.track.trackNumber);
        let time = new Date().getTime();
        if (time - lastClick.current <= DOUBLE_CLICK) {
            if (props.isSelected) {
                props.setPatternSelected(undefined);
            } else {
                props.setBottomMode(PIANO_ROLL);
                props.setPatternSelected(props.event);
            }
        }
        lastClick.current = time;
    }, [props.isSelected, props.event]);

    if (props.isSelected) {
        className += " selected";
        fullStyle.backgroundColor = colors.brighten(style.backgroundColor, 0.1);
        fullStyle.borderColor = style.backgroundColor;
        fullStyle.backgroundColor = colors.brighten(style.backgroundColor, 1.2);
    }

    const onHeaderMouseDown = useCallback((e) => {
        e.stopPropagation();
        props.setCursorStep(undefined);
    }, []);

    let duration = 
              props.event.duration ||
        64;

    return (
        <div
          style={fullStyle}
          className={className}>
          <div
            onMouseDown={onHeaderMouseDown}
            onClick={onClickHeader}
            style={style} className="track-pattern-header">
            {props.isFrozen ? "Frozen" : ""}
          </div>
          {getVisualization(
              props.event,
              {tracks: [props.track]},
              duration,
              getBarWidth(1, props.resolution, props.xScale), true)}
        </div>
    );
});

const mapStateToProps = (state, props) => {
    let isSelected = state.arrangement.patternSelected === props.event &&
        state.mix.selectedTrack === props.track.trackNumber;
    return {
        isSelected,
        steps: isSelected ? state.tracks.trackSteps[props.track.trackNumber] : undefined,
    };
};

const mapDispatchToProps = (dispatch) => {
  return {
      setPatternSelected: (x) => dispatch(setArrangementPatternSelected(x)),
      setCursorStep: (x) => dispatch(
            setArrangementCursorStep(x)),
      setBottomMode: (x) => dispatch(setArrangementBottomMode(x))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TrackPattern);
